import React, { useEffect, useRef, useState } from "react";
import { UserAuth } from "../Context";
import { Link, useLocation } from "react-router-dom";
import {
  onSnapshot,
  doc,
  collection,
  query,
  where,
  updateDoc,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../FirebaseConfig";
import ProfilePicture from "../UserProfile/ProfilePicture";
import ShareMenu from "../Referral/ShareMenu";
import Notification from "../Notifications/Notification";
import { useFetchUserData } from "../hooks/user/useFetchUserData";
import { Dropdown } from "react-bootstrap";
import { Gear } from "react-bootstrap-icons";
import useChatClient from "../StatesStore/ChatClient";
import useModalStore from "../StatesStore/ModalStore";
import useSearchInputStore from "../StatesStore/SearchInputStore";
import useSearchBarOpenState from "../StatesStore/SearchBarOpen";
import useUrlState from "../StatesStore/CurrentURL";
import useChatOpen from "../StatesStore/ChatOpen";
import WebFont from "webfontloader";
import NotificationPannel from "../Notifications/MobileView.js/NotificationPannel";

function UserMenuHeader4() {
  const { user, logOut } = UserAuth();
  // const { theme, setTheme } = useThemeState();
  const { openModal } = useModalStore();
  const { isSearchBarOpen, setIsSearchBarOpen } = useSearchBarOpenState();
  const location = useLocation();
  const { seturl } = useUrlState();
  const { setIsChatOpen } = useChatOpen();
  const [totalShoppingListCount, setTotalShoppingList] = useState(0);
  const [cartCount, setCartCount] = useState(0);

  const { userData } = useFetchUserData(user?.uid);
  const dropdownRef = useRef(null);
  const isSmallScreen = window.innerWidth < 768;
  // console.log("lastSeenNotification from userMenuHeader4", lastSeenNotification);
  const [newMessagesCount, setNewMessagesCount] = useState(0);
  const [newNotificationsCount, setNewNotificationsCount] = useState(0);
  const [lastSeenNotification, setLastSeenNotification] = useState(
    userData?.lastSeenNotification || null
  );
  const client = useChatClient((state) => state.client);
  const {
    searchInput,
    setSearchInput,
    resetSearchInput,
  } = useSearchInputStore();

  // useEffect(() => {
  //   setTheme(localStorage.getItem("theme"));
  // }, [theme]);

  const signOutUser = async () => {
    logOut();
  };
  useEffect(() => {
    if (!user) {
      setTotalShoppingList(0);
    }
  }, [user]);
  useEffect(() => {
    if (!client || !user) return;

    // Check if the client is connected by verifying that a user exists on the client.
    if (!client.user) {
      console.warn(
        "StreamChat client is not connected. Skipping event subscription."
      );
      return;
    }

    const handleEvent = (event) => {
      if (event.total_unread_count !== undefined) {
        setNewMessagesCount(event.total_unread_count);
        console.log(`Unread messages count: ${event.total_unread_count}`);
      }
    };

    client.on(handleEvent);
    // Initial fetch for unread count
    client?.getUnreadCount(user?.uid).then((result) => {
      setNewMessagesCount(result?.total_unread_count || 0);
    });

    return () => {
      if (client) {
        client.off(handleEvent);
      }
    };
  }, [client, user]);

  useEffect(() => {
    const fetchShoppingListCount = async () => {
      if (!user) return;
      const userRef = doc(db, "users", user.uid);
      try {
        const unsubscribeShoppingList = onSnapshot(userRef, (doc) => {
          const userData = doc.data();
          const shoppingListCount = userData?.shoppingListCount || 0;
          setTotalShoppingList(shoppingListCount);
        });

        return () => unsubscribeShoppingList(); // Unsubscribe when the component unmounts
      } catch (error) {
        console.error("Error fetching shopping list count:", error);
      }
    };

    fetchShoppingListCount();
  }, [user]);
  useEffect(() => {
    if (!userData) return;

    // User document listener
    const userDocRef = doc(db, "users", user.uid);
    const unsubscribeUserDoc = onSnapshot(userDocRef, (docSnapshot) => {
      const data = docSnapshot.data();

      // Update lastSeenNotification and lastSeenMsgs
      const updatedLastSeenNotification =
        data?.lastSeenNotification || new Date();
      const updatedLastSeenMsgs = data?.lastSeenMsgs || new Date();

      setLastSeenNotification(updatedLastSeenNotification);
      // setLastSeenMsgs(updatedLastSeenMsgs);

      // Notifications query
      const notificationsRef = collection(
        db,
        "users",
        user.uid,
        "notifications"
      );
      const notificationsQuery = query(
        notificationsRef,
        where("timestamp", ">", updatedLastSeenNotification)
      );

      const unsubscribeNotifications = onSnapshot(
        notificationsQuery,
        (snapshot) => {
          setNewNotificationsCount(snapshot.size);
        }
      );

      // Cleanup function for sub-collections
      return () => {
        unsubscribeNotifications();
      };
    });

    // Cleanup for user document listener
    return () => {
      unsubscribeUserDoc();
    };
  }, [userData]);

  useEffect(() => {
    if (!user) {
      setCartCount(0);
      return;
    }

    const cartRef = collection(db, "users", user.uid, "cart");
    const unsubscribeCart = onSnapshot(cartRef, (snapshot) => {
      setCartCount(snapshot.size);
    });

    return () => unsubscribeCart();
  }, [user]);

  const handleOutsideClick = () => {
    const brand = document.getElementById("brandsCollapse");
    // const category = document.getElementById("categoryCollapse");
    const menCategory = document.getElementById("menCollapse");
    const womenCategory = document.getElementById("womenCollapse");
    if (user && brand && brand.classList.contains("show")) {
      brand.classList.remove("show");
    }
    // if (category.classList.contains("show")) {
    //   category.classList.remove("show");
    // }
    if (user && menCategory && menCategory.classList.contains("show")) {
      menCategory.classList.remove("show");
    }
    if (user && womenCategory && womenCategory.classList.contains("show")) {
      womenCategory.classList.remove("show");
    }
  };
  const handleMenuItemClick = () => {
    if (dropdownRef.current) {
      dropdownRef.current.querySelector(".dropdown-toggle").click();
    }
  };
  if (!userData) return null;

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchInput.length > 2) {
      setIsSearchBarOpen(false);
      setSearchInput("");
      window.location.href = `#/search/${searchInput}`;
    }
  };
  const updateTimestamps = async () => {
    if (!user) return;
    const userDocRef = doc(db, "users", user.uid);
    await updateDoc(userDocRef, {
      lastSeenNotification: serverTimestamp(),
      // lastSeenMsgs: serverTimestamp(),
    });

    setLastSeenNotification(new Date());
    setNewNotificationsCount(0);
  };
  const handleDropdownToggle = (isOpen) => {
    // Update timestamps when dropdown is opened
    if (newNotificationsCount > 0) {
      setTimeout(() => {
        updateTimestamps();
      }, 1000);
    }
  };

  const BackgroundOnSvg = ({ children }) => (
    <div
      style={{
        width: "30px",
        height: "30px",
        borderRadius: "8px",
        backgroundColor: "#F1F4FF",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {children}
    </div>
  );
  return (
    <>
      {isSearchBarOpen && isSmallScreen ? (
        <form
          onSubmit={handleSearch}
          className="d-flex align-items-center position-relative w-100"
        >
          <input
            className="w-100"
            type="search"
            name="input"
            style={{
              border: "1px solid #C3C3C3",
              borderRadius: "6px",
              padding: "4px 0px 4px 30px",
              fontSize: "12px",
            }}
            placeholder="Search"
            aria-label="Search"
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
          />
          <button
            type="submit"
            className="bg-transparent position-absolute border-0 m-0"
            style={{ padding: "0px 0px 0px 5px", left: 0 }}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.5077 8.40507C11.1961 8.43809 10.9702 8.71753 11.0032 9.02921C11.0363 9.34089 11.3157 9.56677 11.6274 9.53375L11.5077 8.40507ZM12.9086 10.2886C13.0308 10.5772 13.3638 10.7121 13.6525 10.5899C13.9411 10.4677 14.076 10.1347 13.9538 9.8461L12.9086 10.2886ZM15.2698 14.3706C15.048 14.1492 14.6887 14.1495 14.4673 14.3714C14.2458 14.5932 14.2462 14.9525 14.468 15.1739L15.2698 14.3706ZM17.0316 17.7329C17.2534 17.9544 17.6127 17.9541 17.8342 17.7323C18.0556 17.5104 18.0553 17.1511 17.8334 16.9297L17.0316 17.7329ZM11.6274 9.53375C12.1741 9.47582 12.6943 9.78231 12.9086 10.2886L13.9538 9.8461C13.5447 8.8796 12.5515 8.29448 11.5077 8.40507L11.6274 9.53375ZM14.468 15.1739L17.0316 17.7329L17.8334 16.9297L15.2698 14.3706L14.468 15.1739Z"
                fill="#676A79"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.46452 14.6808C6.76291 13.9772 6.28703 13.0869 6.09593 12.1202C5.90323 11.1508 6.00218 10.1473 6.38068 9.2322C6.75594 8.32225 7.39661 7.54147 8.22224 6.98792C9.89738 5.86438 12.1026 5.86438 13.7777 6.98792C14.6034 7.54147 15.2441 8.32225 15.6193 9.2322C15.9978 10.1473 16.0968 11.1508 15.904 12.1202C15.713 13.0869 15.2371 13.9772 14.5354 14.6808C13.6063 15.6171 12.3314 16.1453 11 16.1453C9.66861 16.1453 8.3937 15.6171 7.46452 14.6808Z"
                stroke="#676A79"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </form>
      ) : (
        <>
          <div
            className="p-0 search-icon d-flex align-items-center d-md-none"
            onClick={() => {
              setIsSearchBarOpen(true);
            }}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.7254 8.01907C12.2801 8.06624 11.9574 8.46544 12.0046 8.91069C12.0518 9.35595 12.451 9.67864 12.8962 9.63147L12.7254 8.01907ZM14.7266 10.7098C14.9012 11.1221 15.3769 11.3149 15.7893 11.1403C16.2016 10.9657 16.3943 10.49 16.2197 10.0777L14.7266 10.7098ZM18.0997 16.5413C17.7829 16.225 17.2696 16.2254 16.9533 16.5424C16.6369 16.8592 16.6374 17.3725 16.9543 17.6888L18.0997 16.5413ZM20.6165 21.3446C20.9335 21.661 21.4467 21.6606 21.7631 21.3436C22.0794 21.0267 22.0789 20.5134 21.762 20.1971L20.6165 21.3446ZM12.8962 9.63147C13.6772 9.54871 14.4205 9.98655 14.7266 10.7098L16.2197 10.0777C15.6353 8.69697 14.2164 7.86108 12.7254 8.01907L12.8962 9.63147ZM16.9543 17.6888L20.6165 21.3446L21.762 20.1971L18.0997 16.5413L16.9543 17.6888Z"
                fill="#676A79"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.19678 16.8033C5.14437 15.7479 4.43055 14.4125 4.14389 12.9624C3.85485 11.5083 4.00328 10.003 4.57102 8.6304C5.13391 7.26548 6.09492 6.09431 7.33336 5.26398C9.84607 3.57867 13.1539 3.57867 15.6666 5.26398C16.9051 6.09431 17.8661 7.26548 18.4289 8.6304C18.9967 10.003 19.1452 11.5083 18.8561 12.9624C18.5695 14.4125 17.8556 15.7479 16.8032 16.8033C15.4095 18.2078 13.4971 19 11.4999 19C9.50291 19 7.59055 18.2078 6.19678 16.8033Z"
                stroke="#676A79"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div
            className="d-none d-md-block"
            onClick={() => {
              handleOutsideClick();
            }}
          >
            <Link
              onClick={() => {
                if (!user?.emailVerified) {
                  openModal("VerifyEmailModal", "", {
                    userName: user?.displayName,
                    email: user?.email,
                  });
                }
                if (location.pathname !== "/chat") {
                  seturl(location.pathname);
                }
                setIsChatOpen(false);
              }}
              to={user?.emailVerified && "/chat"}
              className="p-0 position-relative "
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.25 3.27093C15.8526 2.46262 14.2303 2 12.5 2C7.25329 2 3 6.25329 3 11.5C3 13.0197 3.35684 14.456 3.99129 15.7299C4.15989 16.0684 4.21601 16.4553 4.11826 16.8206L3.55243 18.9354C3.3068 19.8533 4.14666 20.6932 5.06468 20.4476L7.17942 19.8818C7.54473 19.784 7.93165 19.8401 8.27015 20.0087C9.54395 20.6432 10.9803 21 12.5 21C17.7467 21 22 16.7467 22 11.5C22 9.76967 21.5374 8.14733 20.7291 6.75"
                  stroke="#676A79"
                  stroke-linecap="round"
                />
                <path
                  d="M8 12H8.009M11.991 12H12M15.991 12H16"
                  stroke="#676A79"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                {newMessagesCount > 0 && (
                  <circle cx="18.5963" cy="3" r="3" fill="#FF573A" />
                )}
              </svg>
            </Link>
          </div>
          {/* <div
            className="d-none d-md-block"
            onClick={() => handleOutsideClick()}
          >
            <Link
              onClick={() => {
                if (!user?.emailVerified) {
                  openModal("VerifyEmailModal", "", {
                    userName: user?.displayName,
                    email: user?.email,
                  });
                }
              }}
              to={
                user?.emailVerified && `/userProfile/${user?.uid}/shoppinglist`
              }
              className="nav-link p-0 shopping-list-link position-relative "
            >
              <svg
                width="31"
                height="30"
                viewBox="0 0 31 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M25.0001 8.35469V23.8582C25.0001 25.8371 23.5887 26.6696 21.8651 25.7143L16.5316 22.7255C15.9616 22.4116 15.0387 22.4116 14.4687 22.7255L9.13512 25.7143C7.41155 26.6696 6.00012 25.8371 6.00012 23.8582V8.35469C6.00012 6.02098 7.90011 4.11035 10.2208 4.11035H20.7794C23.1001 4.11035 25.0001 6.02098 25.0001 8.35469Z"
                  stroke="#676A79"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </Link>
          </div> */}
          {/* <div onClick={() => handleOutsideClick()}>
            <Link className="nav-link p-0 position-relative" to="/cart">
              {cartCount > 0 && (
                <span
                  className={`d-flex justify-content-center align-items-center position-absolute translate-middle badge rounded-circle bg-danger ${
                    cartCount > 9 ? "px-1" : ""
                  }`}
                  style={{
                    top: "13%",
                    left: "100%",
                    fontSize: "10px",
                    minHeight: "7.5px",
                    minWidth: "7px",
                  }}
                >
                  {cartCount}
                </span>
              )}
              <i
                className={`bi bi-cart${
                  location.pathname.includes("/cart") ? "-fill" : ""
                } fs-4`}
              ></i>
            </Link>
          </div> */}
          <div
            className="userMenuHeaderNotification"
            ref={dropdownRef}
            onClick={() => {
              if (location.pathname !== "/notifications") {
                seturl(location.pathname);
              }
            }}
          >
            <style jsx>
              {`
                .userMenuHeaderNotification .dropdown-toggle::after {
                  display: none;
                }
              `}
            </style>
            {isSmallScreen ? (
              <>
                <div
                  // to={"/profilePage"}
                  className="position-relative"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasNotificationSideBar"
                  aria-controls="offcanvasNotificationSideBar"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15 19C15 19.7956 14.6839 20.5587 14.1213 21.1213C13.5587 21.6839 12.7956 22 12 22C11.2044 22 10.4413 21.6839 9.87869 21.1213C9.31608 20.5587 9 19.7956 9 19"
                      stroke="#676A79"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M5.48303 18.3417C5.02503 18.25 4.62011 17.9998 4.34813 17.6404C4.07616 17.2809 3.95692 16.8384 4.01393 16.4001L4.94968 9.24271C5.18859 7.7712 5.98283 6.43053 7.18631 5.46735C8.3898 4.50416 9.92157 3.98325 11.4999 4.00041C13.0782 3.98325 14.6099 4.50416 15.8134 5.46735C17.0169 6.43053 17.8112 7.7712 18.0501 9.24271L18.9858 16.4001C19.0432 16.8372 18.9252 17.2786 18.6551 17.6379C18.3851 17.9971 17.9823 18.2482 17.5261 18.3417C13.5656 19.2194 9.44343 19.2194 5.48303 18.3417Z"
                      stroke="#676A79"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    {newNotificationsCount > 0 && (
                      <circle cx="16" cy="4" r="3" fill="#D6293E" />
                    )}
                  </svg>

                  {/* {newNotificationsCount > 0 && (
                    <span
                      className={`d-flex justify-content-center align-items-center position-absolute translate-middle badge rounded-circle ${
                        newNotificationsCount > 9 ? "px-1" : ""
                      } bg-danger`}
                      style={{
                        top: "12%",
                        left: "90%",
                        fontSize: "10px",
                        minHeight: "7.5px",
                        minWidth: "7px",
                      }}
                    >
                      {newNotificationsCount}
                    </span>
                  )} */}
                </div>
              </>
            ) : (
              <Dropdown
                align="end"
                autoClose
                onToggle={() => {
                  handleDropdownToggle();
                  handleOutsideClick();
                }}
              >
                <Dropdown.Toggle
                  variant="link"
                  className="nav-link p-0 position-relative"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.2 18.4C15.2 19.0365 14.8207 19.647 14.1456 20.0971C13.4704 20.5471 12.5547 20.8 11.6 20.8C10.6453 20.8 9.72956 20.5471 9.05443 20.0971C8.3793 19.647 8 19.0365 8 18.4"
                      stroke="#676A79"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M5.5819 17.6979C5.09337 17.6001 4.66145 17.3332 4.37134 16.9498C4.08124 16.5663 3.95405 16.0943 4.01486 15.6268L5.01299 7.99225C5.26783 6.42264 6.11502 4.99258 7.39873 3.96519C8.68245 2.93779 10.3163 2.38216 11.9999 2.40046C13.6834 2.38216 15.3172 2.93779 16.6009 3.96519C17.8847 4.99258 18.7319 6.42264 18.9868 7.99225L19.9849 15.6268C20.0461 16.093 19.9202 16.5639 19.6321 16.9471C19.3441 17.3303 18.9145 17.5981 18.4278 17.6979C14.2033 18.6341 9.80632 18.6341 5.5819 17.6979Z"
                      stroke="#676A79"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    {newNotificationsCount > 0 && (
                      <circle cx="18.7982" cy="3" r="3" fill="#FF573A" />
                    )}
                  </svg>
                </Dropdown.Toggle>

                <Dropdown.Menu
                  className="dropdown-animation pt-3 small me-md-n3 pb-0"
                  style={{ width: "28.813rem", borderRadius: "16px" }}
                >
                  <div onClick={handleMenuItemClick}>
                    <Notification
                      user={user}
                      userData={userData}
                      newNotificationsCount={newNotificationsCount}
                    />
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            )}
          </div>
          <div
            className="dropdown userMenuHeader4 d-none d-md-block"
            onClick={() => {
              if (location.pathname !== "/profilePage") {
                seturl(location.pathname);
              }
            }}
          >
            <style jsx>
              {`
                .userMenuHeader4 .dropdown-toggle::after {
                  display: none;
                }
                .userMenuHeader4 .dropdown-item {
                  color: black;
                }
                .userMenuHeader4 .dropdown-item:hover,
                .dropdown-item:focus {
                  color: var(--bs-dropdown-link-hover-color);
                }
              `}
            </style>

            <Dropdown
              align="end"
              autoClose
              onToggle={() => {
                handleOutsideClick();
              }}
            >
              <Dropdown.Toggle
                variant="link"
                className="nav-link p-0 position-relative d-flex align-items-center"
              >
                <div
                  style={{ width: "24px", height: "24px" }}
                  className="d-flex align-items-center justify-content-center"
                >
                  <img
                    src={
                      userData?.photo ||
                      `https://ui-avatars.com/api/?name=${userData?.userName[0]?.toUpperCase()}`
                    }
                    style={{
                      borderRadius: "4px",
                      width: "24px",
                      height: "24px",
                      objectFit: "cover",
                    }}
                    alt=""
                  />
                </div>
              </Dropdown.Toggle>
              <Dropdown.Menu
                className="dropdown-animation small p-0"
                style={{
                  width: "300px",
                  borderRadius: "16px",
                  overflow: "hidden",
                  boxShadow: "0px 0px 8px 0px #00000026",
                }}
              >
                <Dropdown.Item
                  as={Link}
                  to={`/userProfile/${user.uid}/`}
                  className="d-flex w-100 align-items-center"
                  style={{
                    gap: "12px",
                    padding: "12px 16px 16px 16px",
                    borderBottom: "0.6px solid #CECECE",
                  }}
                >
                  <img
                    src={
                      userData?.photo ||
                      `https://ui-avatars.com/api/?name=${userData?.userName[0]?.toUpperCase()}`
                    }
                    style={{
                      borderRadius: "12px",
                      width: "40px",
                      height: "40px",
                      objectFit: "cover",
                    }}
                    alt=""
                  />
                  <div
                    className="d-flex flex-column"
                    style={{
                      gap: "3px",
                      minWidth: 0, // Essential for truncation
                    }}
                  >
                    <div
                      className="text-truncate d-block"
                      style={{
                        fontFamily: "Inter",
                        fontWeight: 500,
                        fontSize: "16px",
                        lineHeight: "100%",
                        letterSpacing: "-1%",
                        width: "100%",
                      }}
                    >
                      {userData?.userName}
                    </div>
                    <div
                      className="text-truncate d-block"
                      style={{
                        fontFamily: "Inter",
                        fontWeight: 500,
                        fontSize: "14px",
                        lineHeight: "120%",
                        letterSpacing: "-1%",
                        color: "#676A79",
                        width: "100%", // Explicit width
                      }}
                      title={userData?.email} // Tooltip fallback
                    >
                      {userData?.email}
                    </div>
                  </div>
                </Dropdown.Item>
                {/* <Dropdown.Item
                  as={Link}
                  to={`/userProfile/${user.uid}/`}
                  className="bg-primary-soft-hover my-3 ms-2 p-0 gap-2 d-flex w-100 align-items-center"
                >
                  <svg
                    style={{ width: "1.2rem" }}
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6 2C6.41421 2 6.75 2.33579 6.75 2.75V4.00977C8.56629 4.13799 10 5.65109 10 7.5V8.5C10 10.3489 8.56625 11.861 6.75 11.9893V17.25C6.75 17.6642 6.41421 18 6 18C5.58579 18 5.25 17.6642 5.25 17.25V11.9893C3.43375 11.861 2 10.3489 2 8.5V7.5C2 5.65109 3.43371 4.13799 5.25 4.00977V2.75C5.25 2.33579 5.58579 2 6 2ZM5.5 5.5C4.39543 5.5 3.5 6.39543 3.5 7.5V8.5C3.5 9.60457 4.39543 10.5 5.5 10.5H6.5C7.60457 10.5 8.5 9.60457 8.5 8.5V7.5C8.5 6.39543 7.60457 5.5 6.5 5.5H5.5Z"
                      fill="#14191F"
                    />
                    <path
                      d="M14 2C14.4142 2 14.75 2.33579 14.75 2.75V8.00977C16.5663 8.13799 18 9.65108 18 11.5V12.5C18 14.3489 16.5663 15.861 14.75 15.9893V17.25C14.75 17.6642 14.4142 18 14 18C13.5858 18 13.25 17.6642 13.25 17.25V15.9893C11.4337 15.861 10 14.3489 10 12.5V11.5C10 9.65108 11.4337 8.13799 13.25 8.00977V2.75C13.25 2.33579 13.5858 2 14 2ZM13.5 9.5C12.3954 9.5 11.5 10.3954 11.5 11.5V12.5C11.5 13.6046 12.3954 14.5 13.5 14.5H14.5C15.6046 14.5 16.5 13.6046 16.5 12.5V11.5C16.5 10.3954 15.6046 9.5 14.5 9.5H13.5Z"
                      fill="#14191F"
                    />
                  </svg>

                  <div style={{ fontSize: "1.2rem" }}>Profile Settings</div>
                </Dropdown.Item> */}

                {/* <Dropdown.Item
                  as={"div"}
                  style={{ cursor: "pointer", padding: "10px 1rem" }}
                  className="w-100"
                  onClick={() => {
                    if (!user?.emailVerified) {
                      openModal("VerifyEmailModal", "", {
                        userName: user?.displayName,
                        email: user?.email,
                      });
                    }
                  }}
                >
                  <ShareMenu BackgroundOnSvg={BackgroundOnSvg} />
                </Dropdown.Item> */}

                <Dropdown.Item
                  as={Link}
                  to={user?.emailVerified ? `/settings/accountSetting` : "#"}
                  onClick={() => {
                    if (!user?.emailVerified) {
                      openModal("VerifyEmailModal", "", {
                        userName: user?.displayName,
                        email: user?.email,
                      });
                    }
                  }}
                  className="w-100 d-flex align-items-center"
                  style={{
                    color: "#676A79",
                    gap: "12px",
                    padding: "10px 1rem",
                    cursor: "pointer",
                  }}
                >
                  <BackgroundOnSvg>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M10 6.875C8.27412 6.875 6.875 8.27411 6.875 10C6.875 11.7259 8.27412 13.125 10 13.125C11.7259 13.125 13.125 11.7259 13.125 10C13.125 8.27411 11.7259 6.875 10 6.875ZM8.125 10C8.125 8.9645 8.9645 8.125 10 8.125C11.0355 8.125 11.875 8.9645 11.875 10C11.875 11.0355 11.0355 11.875 10 11.875C8.9645 11.875 8.125 11.0355 8.125 10Z"
                        fill="#676A79"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M9.97884 1.04175C9.6085 1.04174 9.29925 1.04174 9.04542 1.05906C8.78117 1.07709 8.53158 1.11596 8.28959 1.21619C7.72808 1.44878 7.28194 1.89491 7.04935 2.45643C6.92827 2.74876 6.89548 3.05685 6.88295 3.39171C6.87289 3.66091 6.73704 3.88551 6.53654 4.00126C6.33606 4.11701 6.07363 4.12236 5.83547 3.99648C5.5392 3.83989 5.25599 3.71424 4.94228 3.67294C4.33969 3.59361 3.73027 3.75691 3.24808 4.12691C3.04028 4.28636 2.88181 4.48308 2.73408 4.70291C2.59215 4.91409 2.43756 5.18187 2.25237 5.50264L2.23133 5.53909C2.04613 5.85985 1.89153 6.12761 1.7796 6.35611C1.66309 6.59397 1.57195 6.82957 1.53776 7.08926C1.45843 7.69185 1.62173 8.30126 1.99172 8.7835C2.18432 9.03441 2.43469 9.21691 2.71839 9.39516C2.94654 9.5385 3.07315 9.7685 3.07314 10.0001C3.07313 10.2316 2.94652 10.4616 2.71839 10.6049C2.43466 10.7832 2.18426 10.9657 1.99164 11.2167C1.62164 11.6988 1.45835 12.3082 1.53768 12.9108C1.57187 13.1705 1.66301 13.4062 1.77952 13.644C1.89144 13.8725 2.04604 14.1402 2.23124 14.461L2.25229 14.4975C2.43748 14.8182 2.59207 15.086 2.73399 15.2972C2.88173 15.517 3.04019 15.7137 3.24799 15.8732C3.73019 16.2432 4.33961 16.4065 4.94219 16.3272C5.25589 16.2858 5.53909 16.1602 5.83534 16.0037C6.07353 15.8777 6.33599 15.8831 6.5365 15.9989C6.73702 16.1147 6.87289 16.3392 6.88295 16.6085C6.89548 16.9433 6.92828 17.2514 7.04935 17.5437C7.28194 18.1052 7.72808 18.5514 8.28959 18.784C8.53158 18.8842 8.78117 18.9231 9.04542 18.9411C9.29925 18.9584 9.6085 18.9584 9.97884 18.9584H10.0209C10.3913 18.9584 10.7005 18.9584 10.9544 18.9411C11.2187 18.9231 11.4683 18.8842 11.7103 18.784C12.2718 18.5514 12.7179 18.1052 12.9505 17.5437C13.0716 17.2514 13.1043 16.9433 13.1168 16.6084C13.1269 16.3392 13.2628 16.1147 13.4633 15.9988C13.6638 15.8831 13.9263 15.8777 14.1644 16.0036C14.4607 16.1602 14.7438 16.2858 15.0576 16.3271C15.6602 16.4064 16.2696 16.2432 16.7518 15.8732C16.9596 15.7137 17.118 15.517 17.2658 15.2972C17.4077 15.086 17.5623 14.8182 17.7474 14.4975L17.7685 14.461C17.9537 14.1402 18.1083 13.8724 18.2203 13.6439C18.3368 13.4061 18.4278 13.1705 18.4621 12.9108C18.5414 12.3082 18.3781 11.6987 18.0081 11.2166C17.8155 10.9656 17.5651 10.7832 17.2814 10.6049C17.0533 10.4616 16.9267 10.2316 16.9267 10C16.9267 9.7685 17.0533 9.53858 17.2813 9.39525C17.5652 9.217 17.8156 9.03458 18.0082 8.7835C18.3782 8.30132 18.5415 7.69191 18.4622 7.08931C18.4279 6.82963 18.3368 6.59403 18.2203 6.35616C18.1084 6.12769 17.9538 5.85994 17.7686 5.53921L17.7476 5.50273C17.5623 5.18196 17.4078 4.91415 17.2658 4.70297C17.1181 4.48314 16.9597 4.28641 16.7518 4.12696C16.2697 3.75696 15.6603 3.59366 15.0576 3.673C14.7439 3.7143 14.4608 3.83993 14.1645 3.99651C13.9263 4.12241 13.6638 4.11705 13.4633 4.00128C13.2628 3.88552 13.1269 3.66089 13.1168 3.39167C13.1043 3.05681 13.0716 2.74875 12.9505 2.45643C12.7179 1.89491 12.2718 1.44878 11.7103 1.21619C11.4683 1.11596 11.2187 1.07709 10.9544 1.05906C10.7005 1.04174 10.3913 1.04174 10.0209 1.04175H9.97884ZM8.76792 2.37104C8.83225 2.34441 8.92992 2.31985 9.1305 2.30616C9.33675 2.29209 9.60308 2.29175 9.99992 2.29175C10.3968 2.29175 10.6631 2.29209 10.8693 2.30616C11.0699 2.31985 11.1676 2.34441 11.2318 2.37104C11.4871 2.47676 11.6899 2.67955 11.7956 2.93479C11.829 3.0153 11.8566 3.14081 11.8678 3.43839C11.8924 4.09871 12.2333 4.73449 12.8383 5.08381C13.4433 5.43315 14.1644 5.41041 14.7486 5.10165C15.0118 4.9625 15.1344 4.92368 15.2208 4.91231C15.4947 4.87625 15.7717 4.95047 15.9908 5.11865C16.0461 5.16101 16.1162 5.23332 16.2283 5.40021C16.3437 5.57177 16.4771 5.80225 16.6755 6.14591C16.8739 6.48959 17.0068 6.7204 17.0978 6.90602C17.1862 7.0866 17.2138 7.18347 17.2228 7.25247C17.2589 7.52637 17.1847 7.80339 17.0165 8.02256C16.9634 8.0917 16.8686 8.17841 16.6163 8.33683C16.0569 8.68841 15.6768 9.30141 15.6767 10C15.6767 10.6987 16.0568 11.3117 16.6163 11.6633C16.8685 11.8217 16.9633 11.9084 17.0164 11.9776C17.1846 12.1967 17.2588 12.4737 17.2228 12.7477C17.2137 12.8167 17.1861 12.9135 17.0977 13.0941C17.0068 13.2797 16.8738 13.5105 16.6754 13.8542C16.477 14.1978 16.3436 14.4283 16.2283 14.5999C16.1161 14.7667 16.046 14.8391 15.9908 14.8814C15.7716 15.0497 15.4946 15.1238 15.2207 15.0878C15.1343 15.0764 15.0118 15.0376 14.7485 14.8985C14.1643 14.5897 13.4433 14.567 12.8382 14.9163C12.2333 15.2657 11.8924 15.9014 11.8678 16.5617C11.8566 16.8593 11.829 16.9848 11.7956 17.0654C11.6899 17.3206 11.4871 17.5234 11.2318 17.6292C11.1676 17.6557 11.0699 17.6803 10.8693 17.694C10.6631 17.7081 10.3968 17.7084 9.99992 17.7084C9.60308 17.7084 9.33675 17.7081 9.1305 17.694C8.92992 17.6803 8.83225 17.6557 8.76792 17.6292C8.51275 17.5234 8.30993 17.3206 8.2042 17.0654C8.17085 16.9848 8.14321 16.8593 8.13208 16.5617C8.10739 15.9015 7.76656 15.2657 7.1615 14.9163C6.55645 14.567 5.83544 14.5897 5.25124 14.8985C4.98796 15.0377 4.86544 15.0765 4.77904 15.0878C4.50514 15.1239 4.22813 15.0497 4.00895 14.8815C3.95374 14.8392 3.88363 14.7668 3.77147 14.5999C3.65618 14.4284 3.52272 14.1979 3.3243 13.8542C3.12588 13.5106 2.99301 13.2797 2.90209 13.0942C2.81364 12.9136 2.78607 12.8167 2.77699 12.7477C2.74093 12.4737 2.81515 12.1967 2.98334 11.9776C3.03639 11.9085 3.13126 11.8217 3.38342 11.6633C3.9429 11.3118 4.3231 10.6987 4.32314 10.0002C4.32318 9.30141 3.94296 8.68833 3.38343 8.33675C3.13133 8.17832 3.03646 8.09164 2.98341 8.02251C2.81524 7.80333 2.74101 7.52632 2.77707 7.25241C2.78615 7.18342 2.81372 7.08654 2.90217 6.90597C2.99309 6.72034 3.12596 6.48953 3.32438 6.14586C3.5228 5.80219 3.65625 5.57171 3.77155 5.40016C3.88371 5.23327 3.95382 5.16096 4.00903 5.1186C4.22821 4.95041 4.50522 4.87619 4.77912 4.91225C4.86553 4.92362 4.98805 4.96244 5.25136 5.10161C5.83553 5.41037 6.55651 5.4331 7.16154 5.08379C7.76657 4.73448 8.10739 4.09872 8.13208 3.43843C8.14321 3.14082 8.17085 3.01531 8.2042 2.93479C8.30993 2.67955 8.51275 2.47676 8.76792 2.37104Z"
                        fill="#676A79"
                        stroke-width="0.4"
                      />
                    </svg>
                  </BackgroundOnSvg>
                  <div
                    style={{
                      fontSize: "16px",
                      fontWeight: "400",
                      fontFamily: "Inter",
                      color: "#000000",
                    }}
                  >
                    Profile Settings
                  </div>
                </Dropdown.Item>
                {/* <Dropdown.Item
                  as={Link}
                  to={user?.emailVerified ? `/feedbackForm` : "#"}
                  onClick={() => {
                    if (!user?.emailVerified) {
                      openModal("VerifyEmailModal", "", {
                        userName: user?.displayName,
                        email: user?.email,
                      });
                    }
                  }}
                  className="w-100 d-flex align-items-center"
                  style={{
                    color: "#676A79",
                    gap: "12px",
                    padding: "10px 1rem",
                    cursor: "pointer",
                  }}
                >
                  <BackgroundOnSvg>
                    <svg
                      fill="#676A79"
                      height="19px"
                      width="19px"
                      version="1.1"
                      id="Layer_1"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512.00 512.00"
                      stroke="#676A79"
                      stroke-width="0.0051200099999999995"
                    >
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke="#CCCCCC"
                        stroke-width="1.0240019999999999"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        {" "}
                        <g>
                          {" "}
                          <g>
                            {" "}
                            <path d="M463.996,126.864L340.192,3.061C338.231,1.101,335.574,0,332.803,0H95.726C67.724,0,44.944,22.782,44.944,50.784v410.434 c0,28.001,22.781,50.783,50.783,50.783h320.547c28.002,0,50.783-22.781,50.783-50.783V134.253 C467.056,131.482,465.955,128.824,463.996,126.864z M343.255,35.679l88.127,88.126H373.14c-7.984,0-15.49-3.109-21.134-8.753 c-5.645-5.643-8.752-13.148-8.751-21.131V35.679z M446.158,461.217c0,16.479-13.406,29.885-29.884,29.885H95.726 c-16.479,0-29.885-13.406-29.885-29.885V50.784c0.001-16.479,13.407-29.886,29.885-29.886h226.631v73.021 c-0.002,13.565,5.28,26.318,14.871,35.909c9.592,9.592,22.345,14.874,35.911,14.874h73.018V461.217z"></path>{" "}
                          </g>{" "}
                        </g>{" "}
                        <g>
                          {" "}
                          <g>
                            {" "}
                            <path d="M147.789,303.745h-4.678c-5.77,0-10.449,4.678-10.449,10.449s4.679,10.449,10.449,10.449h4.678 c5.77,0,10.449-4.678,10.449-10.449C158.238,308.423,153.559,303.745,147.789,303.745z"></path>{" "}
                          </g>{" "}
                        </g>{" "}
                        <g>
                          {" "}
                          <g>
                            {" "}
                            <path d="M368.889,303.745H181.593c-5.77,0-10.449,4.678-10.449,10.449s4.679,10.449,10.449,10.449h187.296 c5.77,0,10.449-4.678,10.449-10.449C379.338,308.423,374.659,303.745,368.889,303.745z"></path>{" "}
                          </g>{" "}
                        </g>{" "}
                        <g>
                          {" "}
                          <g>
                            {" "}
                            <path d="M147.789,256h-4.678c-5.77,0-10.449,4.678-10.449,10.449c0,5.771,4.679,10.449,10.449,10.449h4.678 c5.77,0,10.449-4.678,10.449-10.449C158.238,260.678,153.559,256,147.789,256z"></path>{" "}
                          </g>{" "}
                        </g>{" "}
                        <g>
                          {" "}
                          <g>
                            {" "}
                            <path d="M368.889,256H181.593c-5.77,0-10.449,4.678-10.449,10.449c0,5.771,4.679,10.449,10.449,10.449h187.296 c5.77,0,10.449-4.678,10.449-10.449C379.338,260.678,374.659,256,368.889,256z"></path>{" "}
                          </g>{" "}
                        </g>{" "}
                        <g>
                          {" "}
                          <g>
                            {" "}
                            <path d="M147.789,208.255h-4.678c-5.77,0-10.449,4.678-10.449,10.449c0,5.771,4.679,10.449,10.449,10.449h4.678 c5.77,0,10.449-4.678,10.449-10.449S153.559,208.255,147.789,208.255z"></path>{" "}
                          </g>{" "}
                        </g>{" "}
                        <g>
                          {" "}
                          <g>
                            {" "}
                            <path d="M368.889,208.255H181.593c-5.77,0-10.449,4.678-10.449,10.449c0,5.771,4.679,10.449,10.449,10.449h187.296 c5.77,0,10.449-4.678,10.449-10.449S374.659,208.255,368.889,208.255z"></path>{" "}
                          </g>{" "}
                        </g>{" "}
                      </g>
                    </svg>
                  </BackgroundOnSvg>
                  <div
                    style={{
                      fontSize: "16px",
                      fontWeight: "400",
                      fontFamily: "Inter",
                      color: "#000000",
                    }}
                  >
                    Share Feedback
                  </div>
                </Dropdown.Item> */}

                {/* <Dropdown.Divider /> */}

                <Dropdown.Item
                  as={Link}
                  to="/SignIn"
                  onClick={signOutUser}
                  className="d-flex w-100 align-items-center"
                  style={{
                    color: "#676A79",
                    gap: "12px",
                    padding: "10px 1rem",
                    cursor: "pointer",
                  }}
                >
                  <BackgroundOnSvg>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.6354 8.02532C5.8703 7.79159 5.87124 7.4117 5.63752 7.17679C5.40379 6.9419 5.02389 6.94095 4.78899 7.17468L5.6354 8.02532ZM2.37699 9.57464C2.14209 9.8084 2.14115 10.1883 2.37488 10.4232C2.6086 10.6581 2.9885 10.659 3.2234 10.4254L2.37699 9.57464ZM3.2234 9.57464C2.9885 9.34096 2.6086 9.34192 2.37488 9.5768C2.14115 9.81168 2.14209 10.1916 2.37699 10.4254L3.2234 9.57464ZM4.78899 12.8254C5.02389 13.059 5.40379 13.0581 5.63752 12.8232C5.87124 12.5883 5.8703 12.2084 5.6354 11.9746L4.78899 12.8254ZM2.8002 9.4C2.46883 9.4 2.2002 9.66864 2.2002 10C2.2002 10.3314 2.46883 10.6 2.8002 10.6V9.4ZM14.0002 10.6C14.3316 10.6 14.6002 10.3314 14.6002 10C14.6002 9.66864 14.3316 9.4 14.0002 9.4V10.6ZM4.78899 7.17468L2.37699 9.57464L3.2234 10.4254L5.6354 8.02532L4.78899 7.17468ZM2.37699 10.4254L4.78899 12.8254L5.6354 11.9746L3.2234 9.57464L2.37699 10.4254ZM2.8002 10.6H14.0002V9.4H2.8002V10.6Z"
                        fill="#676A79"
                      />
                      <path
                        d="M7.6001 12.3999C7.6001 14.1672 9.03282 15.5999 10.8001 15.5999H14.0001C15.7674 15.5999 17.2001 14.1672 17.2001 12.3999V7.5999C17.2001 5.83259 15.7674 4.3999 14.0001 4.3999H10.8001C9.03282 4.3999 7.6001 5.83259 7.6001 7.5999"
                        stroke="#676A79"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </BackgroundOnSvg>
                  <div
                    style={{
                      fontSize: "16px",
                      fontWeight: "400",
                      fontFamily: "Inter",
                      color: "#000000",
                    }}
                  >
                    Sign Out
                  </div>
                </Dropdown.Item>

                {/* <Dropdown.Divider /> */}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </>
      )}
    </>
  );
}

export default UserMenuHeader4;
